import React, { useContext } from 'react';
import { FactoryGptWidget as FGPTWidget } from '@allie/mfe';
import { AllieChatFloatButton } from '@allie/app-ui-lib';
import { env } from '@env';
import { isMobile, isTablet, platformType, platforms } from '../../helpers/utils';
import { AuthContext, UtilsContext } from '../../context';
import { CommonPageProps } from '../../App.types';
import { useAppTranslations } from '../../hooks';

export const FactoryGptWidget: React.FC<CommonPageProps> = ({ basePath, openLogin }) => {
  const { permissions, loggedUser, tryGuestLogin } = useContext(AuthContext);
  const { tracker, company } = useContext(UtilsContext);
  const { CHAT_FLOAT_BUTTON_TITLE } = useAppTranslations();

  if (
    !permissions?.factory_gpt?.view ||
    location.pathname.startsWith('/factory-gpt') ||
    location.pathname.includes('/efficiency/assign-stop-reason')
  ) {
    return null;
  }

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     if (window.Intercom) {
  //       window.Intercom('update', { hide_default_launcher: true });
  //     }
  //   }, 1000);

  //   return () => clearTimeout(timer);
  // }, []);

  return (
    <AllieChatFloatButton title={CHAT_FLOAT_BUTTON_TITLE}>
      <FGPTWidget
        entryPointUrl={env.REACT_APP_FACTORY_GPT_ENTRYPOINT || ''}
        className="page-content"
        basePath={basePath}
        permissions={permissions}
        tryGuestLogin={tryGuestLogin}
        loggedUser={loggedUser}
        openLogin={openLogin}
        isMobile={isMobile}
        isTablet={isTablet}
        tracker={tracker}
        company={company}
        platformType={platformType}
        platforms={platforms}
        isWidget
      />
    </AllieChatFloatButton>
  );
};
